// extracted by mini-css-extract-plugin
module.exports = {"asideLink":"AsideLink_asideLink__26gxs","linkTitle":"AsideLink_linkTitle__1uwwS","linkImage":"AsideLink_linkImage__1WtHj"};